import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const nailImages = [{
  url: 'https://cdn.magicpatterns.com/uploads/dBrFfPLus63QrQp9op7EiN/Efecto_aurora,_¡no_te_vayas_jamas_🥹🪄nailsofinstagram_efectoaurora_nailschrome_nailsnailsn.jpg',
  alt: 'Uñas efecto aurora en tonos rosa'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/wFZaUUQGJvTn5nbffRQNta/Las_que_nunca_fallan❣️nailsofinstagram_frenchnails_beautystudio_nailsonfleek_nailsnatural_.jpg',
  alt: 'Uñas francesas clásicas'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/6K4DqZ8HeAoFHTRdpnGkYg/Poniendome_solo_un_poquito_al_dia,_con_dos_trabajitos_de_hoy_✨🙋🏻_♀️Primera_foto-_Soft_gel_Segu.jpg',
  alt: 'Uñas soft gel con detalle dorado'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/qUkHyPPE77E4owPsK3ypdc/Unas_Soft_Gel,_asi_de_divinas_quedan✨softgelnails_nailsonfleek_nailsartist_nailsonpoint_nai.jpg',
  alt: 'Uñas soft gel francesa amarilla con brillos'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/myAbAY2MWgwGpvXCvzCYS3/Unitas_en_softgel_⚡️Tremendas_softgel_softgelnails_nailsnailsnails_nailsofinsta_nailsonfl.jpg',
  alt: 'Uñas soft gel francesa azul con piedras'
}];
export function NailsGallery() {
  return <section id="nails-gallery" className="w-full py-20 px-4 bg-pink/20" data-id="element-106">
      <div className="max-w-7xl mx-auto" data-id="element-107">
        <div className="text-center mb-16" data-id="element-108">
          <p className="text-gold font-semibold tracking-widest uppercase text-sm mb-3" data-id="element-109">
            Nail Art & Diseños
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4" data-id="element-110">
            Galería de Uñas
          </h2>
          <p className="text-charcoal/70 max-w-2xl mx-auto" data-id="element-111">
            Algunos de nuestros trabajos en soft gel, francesas y diseños
            personalizados
          </p>
          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-112">
            <div className="w-16 h-0.5 bg-gold" data-id="element-113" />
            <div className="w-2 h-2 bg-gold rotate-45" data-id="element-114" />
            <div className="w-16 h-0.5 bg-gold" data-id="element-115" />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-116">
          {nailImages.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative overflow-hidden rounded-2xl shadow-lg shadow-pink/30 hover:shadow-2xl transition-shadow group ${index === 0 ? 'col-span-2 row-span-2 aspect-square md:aspect-auto' : 'aspect-square'}`} data-id="element-117">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-118" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-119" />
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-120">
          <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-gold text-white font-semibold rounded-full hover:bg-gold/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-121">
            Reservar turno
            <ArrowRight className="w-4 h-4" data-id="element-122" />
          </a>
        </div>
      </div>
    </section>;
}